import React from 'react';
import { AlertCircle, Loader2, Check } from 'lucide-react';
import { MessageBubble, Suggestion } from './MessageBubble';

export default function MessageList({ messages, nome, emoji, loading, pendingAction, bottomRef, onSend, onConfirmAction, onCancelAction }) {
  return (
    <div className="flex-1 overflow-y-auto p-3 space-y-3 bg-slate-50" data-testid="chat-messages">
      {messages.length === 0 && (
        <div className="text-center py-8 px-4">
          <div className="text-4xl mb-3">{emoji}</div>
          <p className="font-bold text-sm text-slate-800">Ciao! Sono {nome}.</p>
          <p className="text-xs text-slate-500 mt-1">Posso aiutarti a creare clienti, pratiche, preventivi, fatture, registrare pagamenti, generare report e molto altro.</p>
          <div className="mt-4 space-y-1.5">
            <Suggestion onClick={() => onSend('Mostrami le statistiche aziendali')}>Statistiche aziendali</Suggestion>
            <Suggestion onClick={() => onSend('Quali fatture sono in scadenza?')}>Scadenze incassi</Suggestion>
            <Suggestion onClick={() => onSend('Genera report Excel delle fatture')}>Report Excel fatture</Suggestion>
          </div>
        </div>
      )}
      {messages.map((m, i) => <MessageBubble key={m.id || `${m.role}-${i}`} m={m} nome={nome} />)}
      {pendingAction && (
        <div className="bg-amber-50 border border-amber-200 rounded p-3 text-sm" data-testid="pending-action">
          <p className="font-bold text-amber-800 flex items-center gap-1 mb-2"><AlertCircle size={14} /> Conferma richiesta</p>
          <p className="text-amber-900 mb-3">{pendingAction.description || `Eseguire: ${pendingAction.type}`}</p>
          <div className="flex gap-2">
            <button onClick={onConfirmAction} data-testid="confirm-action"
              className="flex-1 bg-primary text-white text-xs font-bold py-1.5 rounded hover:bg-primary/90 flex items-center justify-center gap-1">
              <Check size={12} /> Conferma
            </button>
            <button onClick={onCancelAction}
              className="flex-1 bg-slate-200 text-slate-700 text-xs font-bold py-1.5 rounded hover:bg-slate-300">
              Annulla
            </button>
          </div>
        </div>
      )}
      {loading && (
        <div className="flex items-center gap-2 text-xs text-slate-500">
          <Loader2 size={14} className="animate-spin" /> {nome} sta pensando...
        </div>
      )}
      <div ref={bottomRef} />
    </div>
  );
}
